import HTTP from "@/_helpers/http";
import { PARTNERWITHDRAW__API } from "@/_helpers/urls";
import { PARTNERWITHDRAW__MUTATIONS } from "../mutation-types";
import { PARTNERWITHDRAW__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
  dashboardwithdraws: [],
  withdraws: [],
  totalApprovedRequests: 0,
  trxMethods: [],
  allStatus: [],
  isLoading: false,
  isFetchLoading: false,
  isUpdating: false,
  excelLoading: false,
  range: null,
  pagination: {
    total: 0,
    perPage: 10,
    currentPage: 1,
    lastPage: 1
  }
};

// Getters
const getters = {};

// Mutations
const mutations = {
  [PARTNERWITHDRAW__MUTATIONS.PARTNERWITHDRAW](state, data) {
    state.withdraws = data?.data?.accounts;
    state.totalApprovedRequests = data?.data?.totalApprovedRequests;
    state.trxMethods = data?.data?.trxMethods;
    state.pagination = data?.data?.pagination;
    state.range = data?.data?.range || null;
  },

  [PARTNERWITHDRAW__MUTATIONS.DASHBOARDPARTNERWITHDRAW](state, data) {
    state.dashboardwithdraws = data.allRequests;
  },
  SET_LOADING(state, data) {
    state.isLoading = data;
  },
  SET_FETCH_LOADING(state, data) {
    state.isFetchLoading = data;
  },
  SET_UPDATE_LOADING(state, data) {
    state.isUpdating = data;
  },
  SET_EXCEL_LOADING(state, data) {
    state.excelLoading = data;
  },
};

// Actions
const actions = {
  async [PARTNERWITHDRAW__ACTIONS.PARTNERWITHDRAW](
    { commit, state },
    parameter = {}
  ) {
    try {
      commit("SET_FETCH_LOADING", true);

      const {
        payment_system_id,
        duration,
        status,
        page = 1,
        limit = 10,
        search = ""
      } = parameter;

      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(payment_system_id && { payment_system_id }),
        ...(duration && { duration }),
        ...(status && { status }),
        ...(search && { search })
      }).toString();

      const response = await HTTP().get(
        `${PARTNERWITHDRAW__API.PARTNERWITHDRAW}${queryParams ? `?${queryParams}` : ''}`
      );

      commit(PARTNERWITHDRAW__MUTATIONS.PARTNERWITHDRAW, response.data);
      commit("SET_FETCH_LOADING", false);
    } catch (error) {
      console.log(error);
    }
  },

  async [PARTNERWITHDRAW__ACTIONS.DASHBOARDPARTNERWITHDRAW](
    { commit, state }) {
    try {
      commit("SET_LOADING", true);
      const response = await HTTP().get(PARTNERWITHDRAW__API.DASHBOARDPARTNERWITHDRAW);

      commit(
        PARTNERWITHDRAW__MUTATIONS.DASHBOARDPARTNERWITHDRAW,
        response.data
      );
      commit("SET_LOADING", false);
    } catch (error) {
      console.log(error);
    }
  },

  async [PARTNERWITHDRAW__ACTIONS.CHANGESTATUS](
    { commit, state, dispatch },
    parameter
  ) {
    try {
      const response = await HTTP().post(
        PARTNERWITHDRAW__API.CHANGESTATUS,
        parameter
      );

      if (response.status === 200) {
        await dispatch(PARTNERWITHDRAW__ACTIONS.PARTNERWITHDRAW);
        await dispatch(PARTNERWITHDRAW__ACTIONS.DASHBOARDPARTNERWITHDRAW);
        toast.success(response.data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    }
  },

  async [PARTNERWITHDRAW__ACTIONS.UPDATEWITHDRAW](
    { state, commit, dispatch },
    parameter
  ) {
    try {
      commit("SET_UPDATE_LOADING", true);
      const response = await HTTP().patch(
        PARTNERWITHDRAW__API.UPDATEWITHDRAW,
        parameter
      );

      toast.success(response.data.message);
      await dispatch(PARTNERWITHDRAW__ACTIONS.PARTNERWITHDRAW);
    } catch (error) {
      console.error(error);
    } finally {
      commit("SET_UPDATE_LOADING", false);
    }
  },

  async [PARTNERWITHDRAW__ACTIONS.PARTNERWITHDRAWEXCEL]({ commit }, parameter = {}) {
    try {
      commit("SET_EXCEL_LOADING", true);
  
      const {
        payment_system_id,
        duration,
        status,
        page = 1,
        limit = -1,          // <-- IMPORTANT: for export ALL
        search = ""
      } = parameter;
  
      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(payment_system_id && { payment_system_id }),
        ...(duration && { duration }),
        ...(status && { status }),
        ...(search && { search })
      }).toString();
  
      const response = await HTTP().get(
        `${PARTNERWITHDRAW__API.PARTNERWITHDRAWEXCEL}${queryParams ? `?${queryParams}` : ''}`,
        { responseType: "blob" }  // important for file download
      );
  
      // Download file
      const blob = new Blob([response.data], { type: "application/vnd.ms-excel" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "partner-withdrawals.xlsx"; // Set the filename
      link.click();
  
      commit("SET_EXCEL_LOADING", false);
    } catch (error) {
      console.error("Error downloading partner withdrawals Excel:", error);
      toast.error("Failed to download Excel file.");
      commit("SET_EXCEL_LOADING", false);
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
